// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bqDFcbv8kaohCQekT205{grid-template-columns:auto auto auto;margin:0 -2px;display:grid}.bqDFcbv8kaohCQekT205.sciqIszS48wVXIHDQDmJ{margin:0 -10px}.Gb_d34GQUbYpA1jT_clu{cursor:pointer;-webkit-user-select:none;user-select:none;border-radius:6px;outline:none;flex-direction:column;justify-content:center;align-items:center;height:58px;display:flex}.sciqIszS48wVXIHDQDmJ .Gb_d34GQUbYpA1jT_clu{height:55px}.Gb_d34GQUbYpA1jT_clu:hover{background:var(--background-neutral-subtle)}.cp7OeScitIOI_LwTDsre{color:var(--content-primary-primary);margin-bottom:6px;font-size:20px;font-weight:500}.sciqIszS48wVXIHDQDmJ .cp7OeScitIOI_LwTDsre{margin-bottom:4px}.cMmcJ8BkXCwYKt4sQB1h{color:var(--content-primary-tertiary);letter-spacing:1px;height:10px;font-size:11px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialpad": `bqDFcbv8kaohCQekT205`,
	"small": `sciqIszS48wVXIHDQDmJ`,
	"dialpad__item": `Gb_d34GQUbYpA1jT_clu`,
	"dialpadItem": `Gb_d34GQUbYpA1jT_clu`,
	"dialpad__number": `cp7OeScitIOI_LwTDsre`,
	"dialpadNumber": `cp7OeScitIOI_LwTDsre`,
	"dialpad__symbols": `cMmcJ8BkXCwYKt4sQB1h`,
	"dialpadSymbols": `cMmcJ8BkXCwYKt4sQB1h`
};
export default ___CSS_LOADER_EXPORT___;
